module.exports = __webpack_public_path__ + "img/video-icon.3e63d1ca.png";